import { Component, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ControlsOf } from '../../../shared/forms/forms-common';
import { IRegisterCommand } from '../../../shared/model/fss.api';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../../shared/ui/button/button';
import { Arrow } from '../../../shared/icons/arrow/arrow';
import { Checkbox } from 'primeng/checkbox';
import { Building05 } from '../../../shared/icons/building-05/building-05';
import { UserCircle } from '../../../shared/icons/user-circle/user-circle';

@Component({
  standalone: true,
  selector: 'app-register-step-1',
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    ButtonComponent,
    Arrow,
    Checkbox,
    FormsModule,
    Building05,
    UserCircle,
  ],
  templateUrl: './register-step-1.html',
  styleUrl: './register-step-1.scss',
})
export class RegisterStep1 {
  form = input.required<FormGroup<ControlsOf<IRegisterCommand>>>();
  isValid = input.required<boolean>();

  checkboxStyle = {
    borderRadius: '6px',
    borderColor: '#E1E2E5',
    checkedBackground: '#17B26A',
    checkedBorderColor: '#17B26A',
    checkedHoverBackground: '#17B26A',
    checkedHoverBorderColor: '#17B26A',
    icon: {
      checkedColor: '#FFFFFF',
      checkedHoverColor: '#FFFFFF',
    },
  };

  next = output<void>();

  selectType(isLegal: boolean): void {
    this.form().controls.isLegalEntity!.setValue(isLegal);
  }

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
